import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import styled from '@emotion/styled';
import { Box, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
export const WrapperStyled = styled('div')(({ theme }) => ({
    backgroundColor: theme.palette.background.default,
    width: '100%',
    height: '100%',
    alignContent: 'center',
    'a:link, a:visited, a:active, a:hover, .password-toggle, .forgot-password': {
        fontSize: '1em',
        fontWeight: 300,
        lineHeight: '162%' /* 25.92px */,
        textDecorationLine: 'underline',
        cursor: 'pointer',
        color: theme.palette.link.primary,
        fontFamily: theme.typography.fontFamily,
        textUnderlineOffset: '4px',
    },
    '.italic': {
        fontStyle: 'italic',
    },
    '.form-input, .max-width': {
        maxWidth: '368px',
        minWith: '90%',
    },
}));
export const ContentContainer = {
    display: 'flex',
    justifyContent: 'center',
    justifySelf: 'center',
    alignContent: 'center',
    width: '80vw',
};
export const SplitHalf = {
    width: '50%',
    zIndex: 1,
    top: 0,
    overflowX: 'hidden',
    padding: '5rem 3rem',
};
export const Divider = () => {
    return _jsx("hr", { style: { border: '1px solid #3e4551' } });
};
export const WorkforceSection = () => {
    const theme = useTheme();
    return (_jsx(_Fragment, { children: _jsxs(Box, { sx: Object.assign(Object.assign({}, SplitHalf), { left: 0, margin: 0, alignContent: 'center' }), children: [_jsx(Box, { sx: { mb: 3 }, children: _jsx("img", { src: "/img/workforce-logo-lg-white.svg", alt: "Workforce", style: { width: '22.5rem', maxWidth: '95%' } }) }), _jsxs(Box, { children: [_jsx(Typography, { variant: "h3", sx: { mb: 3 }, children: "Revolutionize Your Business" }), _jsx(Typography, { style: { fontSize: '.8rem' }, sx: { color: theme.typography.textColor.secondary }, children: "Build, test, and deploy AI workflows effortlessly with our intuitive, low-code interface." })] }), _jsxs(Box, { style: { justifySelf: 'end', justifyItems: 'center', display: 'grid', marginTop: '2rem' }, children: [_jsx("img", { src: "/img/pstudio.svg", alt: "ProductStudio", style: { width: '6rem', paddingLeft: '.7rem', maxWidth: '95%' } }), _jsx("img", { src: "/img/company-logo.svg", alt: "Agile Defense", style: { width: '13rem', maxWidth: '95%' } }), _jsx("a", { target: "blank", href: "https://agiledefense.com/", style: { textUnderlineOffset: '4px', fontSize: '.75rem', paddingLeft: '1rem' }, sx: { color: theme.typography.textColor.secondary }, children: "agiledefense.com" })] })] }) }));
};
//# sourceMappingURL=index.js.map